<template>
  <div id="app" v-wechat-title="$route.meta.title=$t('headerTitle')" img-set="/static/logo.png" >
    <Header />
<!--    <transition name="fade">-->
     <router-view/>
<!--    </transition>-->
<!--    <span class="clearfix" />-->

    <el-backtop right="70" bottom="70"/>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  // watch: {
  //   '$route' (to, from) {
  //
  //   }
  // },
  data(){
    return {
      transitionName: ''
      // imgArr:[
      //   require('@/assets/images/产品-进出口背景.jpg'),
      //   require('@/assets/images/产品-冷链物流背景.jpg'),
      //   require('@/assets/images/产品-生态农业背景.jpg'),
      //   require('@/assets/images/毅都概览-1.png'),
      //   require('@/assets/images/毅都概览-2.png'),
      //   require('@/assets/images/企业文化-1.png'),
      //   require('@/assets/images/企业文化-2.png'),
      //   require('@/assets/images/发展历程-1.png'),
      //   require('@/assets/images/发展历程-2.png')
      // ],
      // imgCount:0
    }
  },
  mounted() {
    // this.loadingImg()
  },
  methods:{
  //   loadingImg(){
  //     let imgArr = this.imgArr
  //     let imgCount = this.imgCount
  //     for(let img of imgArr){
  //       let image = new Image()
  //       image.src = img
  //       image.onload = ()=>{
  //         imgCount++
  //         console.log(imgCount)
  //         if( imgCount === imgArr.length ){
  //           this.$router.push('/Home')
  //         }
  //       }
  //     }
  //   }
  }
}
</script>

<style lang="scss">
#app {
  font-family:  Microsoft YaHei,'Avenir',Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #666666;
  font-size:16px;
  font-weight:400;
  /*cursor:default*/
}
/*.fade-enter-active, .fade-leave-active {*/
/*  transition: opacity 1s*/
/*}*/
/*.fade-enter, .fade-leave-to !* .fade-leave-active in <2.1.8 *! {*/
/*  opacity: 0*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue